/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CreateSputumTestDtoInterpretation =
  (typeof CreateSputumTestDtoInterpretation)[keyof typeof CreateSputumTestDtoInterpretation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSputumTestDtoInterpretation = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  INDETERMINATE: 'INDETERMINATE',
  NOT_EXECUTED: 'NOT_EXECUTED',
  PENDING: 'PENDING',
  NONE: 'NONE',
} as const;
